import React from 'react'

export default function Nav() {
  return (
    <nav className='nav-eyebrow'>
      <a
        href='https://www.gpsenterprise.cn/auth/login'
        target='_blank'
        className='nav-eyebrow__login'
      >
        登录
      </a>

      <span className='nav-eyebrow__lang'>
        <svg className='nav-eyebrow__lang-svg'>
          {/* <use xlink:href='#icon-language' href='#icon-language'></use> */}
        </svg>

        <span className='nav-eyebrow__lang__items'>
          <a className='nav-eyebrow__lang__items__item current-lang'>中文</a>

          <span className='nav-eyebrow__lang__dropdown'>
            <a
              className='nav-eyebrow__lang__items__item'
              href='https://analyticpartners.com/'
            >
              en
            </a>
            <a
              className='nav-eyebrow__lang__items__item'
              href='https://analyticpartners.com/de/'
            >
              de
            </a>
            <a
              className='nav-eyebrow__lang__items__item'
              href='https://analyticpartners.com/fr/'
            >
              fr
            </a>
          </span>
        </span>
      </span>
    </nav>
  )
}
